var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.currentJob.apiJob?.output, function (output) {
      return _vm.complete
        ? _c(
            "div",
            {
              staticClass: "file-item flex-column flex-md-row",
              class: { "bg-selected": _vm.isSelected(output) === true },
              on: {
                click: function ($event) {
                  return _vm.toggleSelection(output)
                },
              },
            },
            [
              _c("div", { staticClass: "item d-inline-flex gap-10px" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.isSelected(output) },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item hoverFileListItem",
                    on: {
                      mousemove: function ($event) {
                        return _vm.mouseOver(output)
                      },
                      mouseenter: function ($event) {
                        return _vm.mouseEnter(output)
                      },
                      mouseleave: function ($event) {
                        return _vm.mouseOut(output)
                      },
                    },
                  },
                  [
                    _vm.canPreviewMini(output) === false ||
                    _vm.currentJob.thumbnails.small_enabled === false
                      ? _c("div", { staticClass: "thumb-small no-preview" }, [
                          _c("i", { staticClass: "far fa-file" }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canPreviewMini(output) &&
                    _vm.currentJob.thumbnails.small_enabled === true
                      ? _c(
                          "div",
                          {
                            staticClass: "thumb-small",
                            class: {
                              "filename-cursor":
                                _vm.canPreview(output) === true,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openPreview(output)
                              },
                            },
                          },
                          [
                            _vm.isSmallThumbnailByOutputLoading(output)
                              ? _c("div", [_vm._m(0, true)])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "bg-checkered" }, [
                              !_vm.isSmallThumbnailByOutputLoading(output)
                                ? _c("img", {
                                    attrs: {
                                      id: "previewed-image",
                                      src: _vm.getThumbnailForOutput(output),
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "filename-cursor short-text-name",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-trigger": "hover",
                      title: _vm._f("trans")("Right-Click, Save As"),
                      href: output.download_uri,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.download(output)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("decodeUrl")(
                          _vm._f("getFilenameFromUrl")(output.uri)
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "text-muted",
                    class: {
                      "line-through": _vm.isCompressJob() === true,
                      "d-none":
                        (_vm.isCompressJob() === true &&
                          !_vm.isOutputSmaller(output)) ||
                        _vm.isCompressJob() === false,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.getReadableSize(
                            _vm.getInputForOutput(output).size
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getReadableSize(output.size)) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "position-relative" }, [
                  _vm.hoverOutput.id === output.id
                    ? _c("div", { staticClass: "thumb-preview" }, [
                        _vm.isSmallThumbnailByOutputLoading(_vm.hoverOutput)
                          ? _c("div", { staticClass: "placeholder" }, [
                              _c("div", { staticClass: "animated-background" }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "w-100 h-100 bg-checkered" }, [
                          !_vm.isSmallThumbnailByOutputLoading(_vm.hoverOutput)
                            ? _c("img", {
                                staticClass: "w-100 h-auto",
                                attrs: {
                                  id: "previewed-image",
                                  src: _vm.getThumbnailForOutput(
                                    _vm.hoverOutput
                                  ),
                                },
                                on: { load: _vm.imageChanged },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item" }, [
                output.status === "uploading"
                  ? _c("i", {
                      staticClass:
                        "fa fa-spin btn-loading-animation lh-inherit spinner-basic",
                    })
                  : _vm._e(),
                _vm._v(" "),
                output.status === "uploading-init"
                  ? _c("i", { staticClass: "far fa-cloud-upload" })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex-grow-1 justify-content-end d-flex file-actions item align-items-center flex-wrap",
                },
                [
                  _vm.isCompressJob() === true
                    ? _c("div", [
                        _vm.isOutputSmaller(output)
                          ? _c("div", { staticClass: "compress-success m-0" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm._f("trans")("Compressed by")) +
                                    "\n          " +
                                    _vm._s(
                                      _vm.getCompressDiff(output).diff_perc
                                    ) +
                                    "%\n        "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isOutputSmaller(output) === false
                          ? _c("div", { staticClass: "compress-failed m-0" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "Can't compress any further"
                                    )
                                  ) + "\n        "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "file-action-btn",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-trigger": "hover",
                          title: _vm._f("trans")("File Info"),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openFileInfo(output)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "20",
                              viewBox: "0 0 16 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M10 1V5C10 5.26522 10.1054 5.51957 10.2929 5.70711C10.4804 5.89464 10.7348 6 11 6H15",
                                stroke: "#2E2E2E",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M13 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H10L15 6V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19Z",
                                stroke: "#2E2E2E",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M7 12H8V16H9M8 9H8.01",
                                stroke: "#2E2E2E",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("trans")("Info")) +
                            " \n      "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.canPreview(output)
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "file-action-btn",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-trigger": "hover",
                              title: _vm._f("trans")("Preview"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openPreview(output)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 24 24",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm._f("trans")("Preview")) +
                                "\n      "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  true === false
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "upload-btn",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-trigger": "hover",
                              title: _vm._f("trans")("Upload To Cloud"),
                            },
                          },
                          [_c("i", { staticClass: "far fa-cloud-upload" })]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "download-btn gap-10px",
                        attrs: {
                          href: output.download_uri,
                          title: _vm._f("trans")("Download"),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.download(output)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "far fa-download lh-inherit" }),
                        _vm._v(_vm._s(_vm._f("trans")("Download"))),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "placeholder" }, [
      _c("div", { staticClass: "animated-background" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }